import { render, staticRenderFns } from "./StudentClasses.vue?vue&type=template&id=f9194b16"
import script from "./StudentClasses.vue?vue&type=script&lang=js"
export * from "./StudentClasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports